// extracted by css-extract-rspack-plugin
export default {"row":"row-x67wF4","cell":"cell-W_fePM","tableWrap":"tableWrap-xEEyyK"};